/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Ai_Tools_Menu_Aria_LabelInputs */

const en_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show AI Tools menu`)
};

const fr_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afficher le menu des outils IA`)
};

const de_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menü „KI-Tools anzeigen“`)
};

const it_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostra il menu Strumenti AI`)
};

const ru_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Показать меню «Инструменты ИИ»`)
};

const es_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar el menú de herramientas de IA`)
};

const zh_cn2_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`显示 AI 工具菜单`)
};

const ja_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AIツールメニューを表示`)
};

const hi_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एआई टूल्स मेनू दिखाएँ`)
};

const pt_pt2_event_ad_ai_tools_menu_aria_label = /** @type {(inputs: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mostrar menu de ferramentas de IA`)
};

/**
* | output |
* | --- |
* | "Show AI Tools menu" |
*
* @param {Event_Ad_Ai_Tools_Menu_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_ai_tools_menu_aria_label = /** @type {((inputs?: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Ai_Tools_Menu_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_ad_ai_tools_menu_aria_label(inputs)
	if (locale === "de") return de_event_ad_ai_tools_menu_aria_label(inputs)
	if (locale === "it") return it_event_ad_ai_tools_menu_aria_label(inputs)
	if (locale === "ru") return ru_event_ad_ai_tools_menu_aria_label(inputs)
	if (locale === "es") return es_event_ad_ai_tools_menu_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_ad_ai_tools_menu_aria_label(inputs)
	if (locale === "ja") return ja_event_ad_ai_tools_menu_aria_label(inputs)
	if (locale === "hi") return hi_event_ad_ai_tools_menu_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_ad_ai_tools_menu_aria_label(inputs)
	return en_event_ad_ai_tools_menu_aria_label(inputs)
});